var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9972 7.56064C19.9972 8.79818 19.0029 9.80053 17.7753 9.80053H2.22191C0.994306 9.80053 0 8.79818 0 7.56064C0 6.3231 0.994306 5.32075 2.22191 5.32075H4.14109L7.08513 0.406984C7.32398 0.00940297 7.83502 -0.119391 8.22941 0.121398C8.6238 0.362186 8.75156 0.877361 8.51271 1.27494L6.09082 5.32075H13.9231L11.529 1.27214C11.2929 0.874562 11.4234 0.359386 11.8178 0.121398C12.2122 -0.113791 12.726 0.0150027 12.9593 0.412584L15.8645 5.32075H17.7781C19.0057 5.32075 20 6.3231 20 7.56064H19.9972ZM18.1947 11.2901L17.5198 17.9761C17.3643 19.6897 16.6532 21 14.2091 21H5.8103C3.32176 21 2.6663 19.6897 2.48854 17.9761L1.8053 11.2901C1.78586 11.0913 1.93862 10.9205 2.13581 10.9205H17.8614C18.0586 10.9205 18.2141 11.0913 18.1919 11.2901H18.1947ZM8.63213 13.7203C8.63213 13.2612 8.25441 12.8804 7.79892 12.8804C7.34342 12.8804 6.9657 13.2612 6.9657 13.7203V17.0802C6.9657 17.5394 7.33231 17.9201 7.79892 17.9201C8.26552 17.9201 8.63213 17.5394 8.63213 17.0802V13.7203ZM13.076 13.7203C13.076 13.2612 12.6982 12.8804 12.2427 12.8804C11.7873 12.8804 11.4095 13.2612 11.4095 13.7203V17.0802C11.4095 17.5394 11.7761 17.9201 12.2427 17.9201C12.7093 17.9201 13.076 17.5394 13.076 17.0802V13.7203Z",
    fill: "#2C2B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerce);
export default __webpack_public_path__ + "static/media/ecommerce.a4fd5bd7b850621d5d6496c2bd9362b9.svg";
export { ForwardRef as ReactComponent };